import { OptionsField } from '../field/options.field'

export abstract class AntOptionsField extends OptionsField {
  isHorizontal: boolean
  constructor(options: OptionsField & { isHorizontal?: boolean }) {
    super(options)
    this.isHorizontal = options.isHorizontal == undefined ? true : options.isHorizontal
  }
}
